//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListEditInput from './ListEditInput';

export default {
  name: 'ListEdit',
  components: { ListEditInput },
  props: {
    dataForm: { type: [Array, Object], default: () => {} },
    addApi: { type: String, default: '' },
    updateApi: { type: String, default: '' },
    deleteApi: { type: String, default: '' },
  },
  data() {
    return {
      newContent: '',
    };
  },
  methods: {
    saveItem(content) {
      if (!this.addApi) return;

      this.$api(this.addApi, { content }).then(() => {
        this.$emit('getData');
        this.newContent = '';
      });
    },
    updateItem(item) {
      if (!this.updateApi) return;

      this.$api(this.updateApi, item).then(() => {
        this.$emit('getData');
      });
    },
    removeItem(id) {
      if (!this.deleteApi) return;

      this.$api(this.deleteApi, { id }).then(() => {
        this.$emit('getData');
      });
    },
  },
};
